(function () {
        // Upgrade-to-stack bundle add:
        // - Item 1: main selected variant, includes selling_plan if present (Seal handles selection)
        // - Item 2: addon product first available variant, always one-time purchase
        // Defensive by design: does not mutate existing ATC form behavior.

        const btn = document.querySelector('[data-upgrade-to-stack]');
        if (!btn) return;

        let isSubmitting = false;
        const originalText = btn.textContent;

        function setLoading(loading) {
          isSubmitting = loading;
          btn.disabled = loading;
          btn.setAttribute('aria-busy', loading ? 'true' : 'false');
          btn.textContent = loading ? 'Adding…' : originalText;
        }

        function getMainForm() {
          // Always prefer the PDP form that this button lives inside.
          // After the first add, the cart drawer injects its own /cart/add forms (upsells, etc),
          // so a global querySelector can accidentally target the wrong form.
          const closestForm = btn.closest('form');
          if (closestForm) return closestForm;

          // Fallback: pick the first product form that contains the button.
          const holder = btn.closest('[data-form-wrapper], [data-product], [data-product-form], .product-single__details') || document;
          return holder.querySelector('form[action$="/cart/add"]');
        }

        function getSelectedMainVariantId(form) {
          // Existing form already maintains selected variant in input[name="id"].
          const idEl = form ? form.querySelector('input[name="id"]') : null;
          const raw = idEl ? String(idEl.value || '').trim() : '';
          const id = raw ? Number(raw) : NaN;
          return Number.isFinite(id) ? id : null;
        }

        function getSelectedSellingPlanId(form) {
          // Seal typically writes selected selling plan into input/select[name="selling_plan"] inside the same form.
          // If blank / not present, treat as one-time purchase (no selling_plan field).
          const spEl = form ? form.querySelector('[name="selling_plan"]') : null;
          if (!spEl) return null;
          const raw = String(spEl.value || '').trim();
          if (!raw) return null;
          const id = Number(raw);
          return Number.isFinite(id) ? id : null;
        }

        function getAddonVariantId() {
          const raw = btn.getAttribute('data-addon-variant-id');
          const id = raw ? Number(String(raw).trim()) : NaN;
          return Number.isFinite(id) ? id : null;
        }

        async function addUpgradeBundle() {
          if (isSubmitting) return;
          setLoading(true);

          try {
            const form = getMainForm();
            const mainVariantId = getSelectedMainVariantId(form);
            const sellingPlanId = getSelectedSellingPlanId(form);
            const addonVariantId = getAddonVariantId();

            if (!mainVariantId || !addonVariantId) {
              throw new Error('Missing variant IDs for upgrade bundle.');
            }

            const mainItem = {
              id: mainVariantId,
              quantity: 1,
              properties: { _upgrade_bundle: 'true' }
            };

            // Only include selling_plan when a valid plan is currently selected.
            if (sellingPlanId) {
              mainItem.selling_plan = sellingPlanId;
            }

            const payload = {
              items: [
                mainItem,
                {
                  id: addonVariantId,
                  quantity: 1,
                  properties: { _linked_addon: 'true' }
                }
              ]
            };

            const res = await fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify(payload)
            });

            if (!res.ok) {
              // cart/add.js returns JSON error body; try to surface message when possible.
              let errText = 'Failed to add items to cart.';
              try {
                const errJson = await res.json();
                if (errJson && errJson.description) errText = errJson.description;
                else if (errJson && errJson.message) errText = errJson.message;
              } catch (e) {}
              throw new Error(errText);
            }

            // Success: use Palo Alto theme cart drawer controller (window.cart).
            // In theme.js, default add-to-cart calls `window.cart.getCart()` which re-renders the cart drawer
            // and opens it (if drawer cart type is enabled).
            try {
              if (window.cart && typeof window.cart.getCart === 'function') {
                // Ensure the theme re-fetches and re-renders the cart UI.
                window.cart.getCart();
              } else {
                // Fallback: try clicking the cart drawer toggle if present in markup.
                const cartToggle = document.querySelector('[data-cart-drawer-toggle]');
                if (cartToggle) cartToggle.click();
              }
            } catch (e) {
              console.warn('[Upgrade to Stack] Unable to update/open cart drawer:', e);
            }

            // Also dispatch a specific event in case you want to hook into it later.
            try {
              document.dispatchEvent(new CustomEvent('upgradeToStack:added', { detail: { mainVariantId, addonVariantId, sellingPlanId } }));
            } catch (e) {}
          } catch (err) {
            console.error('[Upgrade to Stack] Error:', err);
            alert(err && err.message ? err.message : 'Something went wrong. Please try again.');
          } finally {
            setLoading(false);
          }
        }

        btn.addEventListener('click', addUpgradeBundle);
      })();